module.exports = __webpack_public_path__ + "media/images/social-share-button/odnoklassniki-1200d1855cb9e045f1a44de9de08e575.svg";